import { Component, ElementRef } from '@angular/core';

import { IconComponent } from '../../../common/icon/icon.component';

@Component({
  selector: 'rt-drawer-drag-handle',
  template: ` <rt-icon name="drag-vertical" />`,
  styleUrls: ['./drawer-drag-handle.component.less'],
  imports: [IconComponent],
})
export class DrawerDragHandleComponent {
  constructor(public elementRef: ElementRef) {}
}
